export class TweetAuthor {
    constructor(id, username, name) {
        this.id = id;
        this.username = username;
        this.name = name;
    }
    static from(user) {
        return new TweetAuthor(user.id, user.username, user.name);
    }
}
